import React, { useState } from 'react'
import IconMinusCircle from '../../../assets/icons/icon-minus-circle.svg'
import { ADDITIONAL_REQUIREMENTS_DATA } from './requirementData'
import { resolveUrlForArticles } from './utils/urlUtils'
import {
  AdditionalRequirementsSection,
  AdditionalRequirementsHeader,
  AdditionalRequirementsTitle,
  AdditionalRequirementsIcon,
  AdditionalRequirementsTitleText,
  AdditionalRequirementsCount,
  AdditionalRequirementsBody,
  AdditionalRequirementsDescription,
  AdditionalRequirementCard,
  AdditionalRequirementHeader,
  AdditionalRequirementIcon,
  AdditionalRequirementTitle,
  AdditionalRequirementDescription,
  TextButton
} from './Styles/ProgressTracker.styles'

const AdditionalRequirementsList = ({ additionalRequirements, onLevelClick }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  // Work Experience Credits always appears, so total count is dynamic requirements + 1
  const requirementsCount = additionalRequirements.length + 1
  const workExperienceReq = ADDITIONAL_REQUIREMENTS_DATA['work_experience_credits']

  return (
    <AdditionalRequirementsSection>
      <AdditionalRequirementsHeader
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <AdditionalRequirementsTitle>
          <AdditionalRequirementsIcon
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
          />
          <AdditionalRequirementsTitleText>
            Additional Requirements
          </AdditionalRequirementsTitleText>
        </AdditionalRequirementsTitle>
        <AdditionalRequirementsCount>
          {requirementsCount}
        </AdditionalRequirementsCount>
      </AdditionalRequirementsHeader>

      {isExpanded && (
        <AdditionalRequirementsBody>
          <AdditionalRequirementsDescription>
            Additional requirements do not need to be completed in a specific level but must be completed before applying for PGA of America Membership.
          </AdditionalRequirementsDescription>

          {additionalRequirements.map((requirement) => {
            const reqData = ADDITIONAL_REQUIREMENTS_DATA[requirement.id]
            if (!reqData) return null

            return (
              <AdditionalRequirementCard key={requirement.id}>
                <AdditionalRequirementHeader>
                  <AdditionalRequirementIcon src={IconMinusCircle} alt="" />
                  <AdditionalRequirementTitle>
                    {reqData.name}
                  </AdditionalRequirementTitle>
                </AdditionalRequirementHeader>
                <AdditionalRequirementDescription>
                  {reqData.description}{' '}
                  {reqData.linkAction ? (
                    <TextButton onClick={() => onLevelClick && onLevelClick(reqData.linkAction)}>
                      {reqData.linkText}
                    </TextButton>
                  ) : reqData.linkUrl ? (
                    <TextButton as="a" href={resolveUrlForArticles(reqData.linkUrl)} target="_blank" rel="noopener noreferrer">
                      {reqData.linkText}
                    </TextButton>
                  ) : null}
                </AdditionalRequirementDescription>
              </AdditionalRequirementCard>
            )
          })}

          {/* Work Experience Credits - not tied to requirement data; always appears */}
          <AdditionalRequirementCard>
            <AdditionalRequirementHeader>
              <AdditionalRequirementIcon src={IconMinusCircle} alt="" />
              <AdditionalRequirementTitle>
                {workExperienceReq.name}
              </AdditionalRequirementTitle>
            </AdditionalRequirementHeader>
            <AdditionalRequirementDescription>
              {workExperienceReq.description}{' '}
              {workExperienceReq.linkUrl && (
                <TextButton as="a" href={resolveUrlForArticles(workExperienceReq.linkUrl)} target="_blank" rel="noopener noreferrer">
                  {workExperienceReq.linkText}
                </TextButton>
              )}
            </AdditionalRequirementDescription>
          </AdditionalRequirementCard>
        </AdditionalRequirementsBody>
      )}
    </AdditionalRequirementsSection>
  )
}

export default AdditionalRequirementsList
